import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { share, map, catchError } from "rxjs/operators";

@Injectable()
export class LogInStatusService {
  public static SECURED = "2";
  public static UNSECURED = "1";
  public static GUEST = "0";

  constructor(private http: HttpClient) {}

  public isUserLoggedIn(): Observable<any> {
    return this.accessLevel.pipe(
      map(accessLevel => {
        return (
          accessLevel && accessLevel.status === LogInStatusService.SECURED
        );
      })
    );
  }

  public getCustomerDetails(): Observable<any> {
    return this.http.get<any>("/loyalty/api/member-information").pipe(share());
  }

  public get accessLevel(): Observable<any> {
    return this.http.get<any>("/loyalty/access-level").pipe(
      catchError(error => {
        if (error.status === 404) {
          return of({ status: LogInStatusService.GUEST });
        }

        return of(error);
      }),
      share()
    );
  }
}